import { render, staticRenderFns } from "./TiqueteElectronico.vue?vue&type=template&id=22225d3a&scoped=true"
import script from "./TiqueteElectronico.vue?vue&type=script&lang=js"
export * from "./TiqueteElectronico.vue?vue&type=script&lang=js"
import style0 from "./TiqueteElectronico.vue?vue&type=style&index=0&id=22225d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22225d3a",
  null
  
)

export default component.exports